import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { timer } from "rxjs";
import { fetchSummaryStatus, fetchTestCaseStatus } from "../services/api";

// Expanding Item
import { Accordion, AccordionSummary, AccordionDetails, Typography, Box } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import Button from "@mui/material/Button";
import HistorySharpIcon from "@mui/icons-material/HistorySharp";

function ServiceItem({ name, status, message, lastChecked, hideExpandable, navigatePath }) {
    const color =
        {
            no_know_issue: "success",
            issue_detected: "error",
        }[status.toLowerCase().replace(/ /g, "_")] || "default";

    const StatusIcon = status.toLowerCase().replace(/ /g, "_") === "no_know_issue" ? CheckCircleIcon : ErrorIcon;

    const navigate = useNavigate();

    const handleNavigate = () => {
        navigate(navigatePath);
    };

    return !hideExpandable ? (
        <Accordion disableGutters>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Box display="flex" alignItems="center" width="100%">
                    <Typography sx={{ flexGrow: 1 }} className="fw-bold">
                        {name}
                    </Typography>
                    <StatusIcon color={color} sx={{ mr: 1 }} />
                    <Typography variant="caption" color="text.secondary">
                        {status}
                    </Typography>
                </Box>
            </AccordionSummary>
            <AccordionDetails>
                <Typography>{message}</Typography>
                <Typography variant="caption" color="text.secondary">
                    Last checked: {!!lastChecked ? new Date(lastChecked).toString() : "-"}
                </Typography>
            </AccordionDetails>
        </Accordion>
    ) : (
        <Accordion disableGutters>
            <AccordionSummary onClick={handleNavigate}>
                <Box display="flex" alignItems="center" width="100%">
                    <Typography sx={{ flexGrow: 1 }} className="fw-bold">
                        {name}
                    </Typography>
                    <StatusIcon color={color} sx={{ mr: 1 }} />
                    <Typography variant="caption" color="text.secondary">
                        {status}
                    </Typography>
                    <KeyboardArrowRightIcon />
                </Box>
            </AccordionSummary>
        </Accordion>
    );
}

function MainPage() {
    const [now, setNow] = useState(new Date().toString());

    const navigate = useNavigate();
    let [data, setData] = useState([]);
    const [tcStatus, setTcStatus] = useState(true);

    const handleNavigate = () => {
        navigate("services-history");
    };

    useEffect(() => {
        timer(0, 1000 * 60 * 5).subscribe({
            next: () => retreivingData(),
        });
    }, []);

    function retreivingData() {
        setNow(new Date().toString());
        fetchSummaryStatus()
            .then((data) => {
                if (!!data) setData(data.sort((a, b) => (a?.name > b?.name ? 1 : a?.name < b?.name ? -1 : 0)));
            })
            .catch((err) => {
                console.error(err);
            });

        fetchTestCaseStatus()
            .then((data) => setTcStatus(data?.status == "success"))
            .catch((err) => {
                console.error(err);
            });
    }

    return (
        <div>
            <div className="PageBanner py-2 shadow-sm">
                <img src="/botnoi-logo-text.svg" alt="Botnoi Logo With Text" />
            </div>
            <div className="container">
                <h1 className="text-center">Status of Botnoi Chatbot Platform</h1>
                <div className="d-flex justify-content-center">
                    <Typography variant="caption" color="text.secondary">
                        Updated {now}
                    </Typography>
                </div>

                <div className="mb-5"></div>

                <div className="row">
                    <div className="col-12 col-md-10 offset-md-1 col-lg-6 offset-lg-3">
                        {/* <div className="IllustrationStatusHeader"> */}
                        {/*     <img src="/banner.png" alt="Monitoring Bannner" className="w-100" /> */}
                        {/* </div> */}

                        <div className="d-block p-3 border rounded-top-3 shadow-sm bg-white">
                            <h4 className="fw-bold mb-0">Service Status</h4>
                        </div>

                        {data.map((d) => (
                            <ServiceItem
                                key={`${d.name.toLowerCase().replace(/ /g, "-")}`}
                                name={d.name}
                                status={d.latest.success ? "No know issue" : "Issue detected"}
                                message={d.latest.message}
                                lastChecked={d.latest.checked_at}
                            />
                        ))}

                        <div className="d-flex align-items-center justify-content-end mt-3">
                            <Button variant="outlined" startIcon={<HistorySharpIcon />} onClick={handleNavigate}>
                                View History
                            </Button>
                        </div>

                        <div className="mb-5"></div>

                        <div className="d-block p-3 border rounded-top-3 shadow-sm bg-white">
                            <h4 className="fw-bold mb-0">Test Cases Status</h4>
                        </div>
                        <ServiceItem
                            name="Chatbot Test Case Results"
                            status={tcStatus ? "No know issue" : "Issue detected"}
                            message=""
                            lastChecked=""
                            hideExpandable={true}
                            navigatePath="testcase"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MainPage;
